export default "__VITE_ASSET__9eab7600__"